import { render, staticRenderFns } from "./ItemSlect.vue?vue&type=template&id=06899410&"
import script from "./ItemSlect.vue?vue&type=script&lang=js&"
export * from "./ItemSlect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports